import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchOneTimeCheckoutUrlByEventId = async (token, eventId, service_type) => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(searchParams);

  const config = {
    headers: { Authorization: `Token ${token}` },
  };
  const res = await axios
    .post(
      `${baseUrl}/checkout/create/`,
      { portal: portal,event:eventId, "service_type": service_type, ...paramsObject },
      config
    )
  return res.data;
}